<script setup lang="ts">
import { ref } from 'vue'
import { MarButton, MarDialog, MarField, MarForm, MarIconPicker, MarTextInput } from '@nimling/components-nimtech'
import { useUiStore } from '@/stores/ui'

const emit = defineEmits<{ close: [result?: string] }>()
const uiStore = useUiStore()

const groupName = ref('')
const groupIcon = ref('folder')

const postGroup = () => {
  const label = groupName.value.trim()
  if (!label) return
  emit('close', uiStore.postSidebarGroup(label, groupIcon.value))
}
</script>

<template>
  <MarDialog title="Create section" @close="emit('close')">
    <div class="sidebar-group-dialog">
      <MarForm @keydown.enter="postGroup">
        <MarField label="Section" help="Groups pages in the sidebar; a page joins it by drag or from its edit page.">
          <MarIconPicker v-model="groupIcon"><MarTextInput v-model="groupName" placeholder="Section name" autofocus /></MarIconPicker>
        </MarField>
      </MarForm>
    </div>

    <template #footer>
      <MarButton label="Cancel" severity="secondary" @click="emit('close')" />
      <MarButton label="Create section" :disabled="!groupName.trim()" @click="postGroup" />
    </template>
  </MarDialog>
</template>

<style scoped>
.sidebar-group-dialog {
  width: min(28em, 85vw);
}
</style>
